import { DashboardCard } from "@dashboard/components/Card";
import RichTextEditor from "@dashboard/components/RichTextEditor";
import { RichTextEditorLoading } from "@dashboard/components/RichTextEditor/RichTextEditorLoading";
import { useExtendedDescriptionRichTextContext } from "@dashboard/utils/richText/context";
import React from "react";

interface CategoryExtendedDescriptionCardProps {
  disabled?: boolean;
}

export const CategoryExtendedDescriptionCard = ({
  disabled,
}: CategoryExtendedDescriptionCardProps) => {
  const { editorRef, defaultValue, isReadyForMount, handleChange } =
    useExtendedDescriptionRichTextContext();

  return (
    <DashboardCard>
      <DashboardCard.Header>
        <DashboardCard.Title>Extended Description</DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        {isReadyForMount ? (
          <RichTextEditor
            editorRef={editorRef}
            defaultValue={defaultValue}
            onChange={handleChange}
            disabled={!!disabled}
            error={false}
            label="Extended Description"
            name="extended_description"
          />
        ) : (
          <RichTextEditorLoading label="Extended Description" name="extended_description" />
        )}
      </DashboardCard.Content>
    </DashboardCard>
  );
};
